import { Link, Stack, Typography } from '@mui/material';
import { DynamicArrow } from 'Components/DynamicArrow';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useNavigate } from 'react-router-dom';

interface INavigateTo {
  label: string;
  href?: string;
}

export const NavigateTo = ({ label, href }: INavigateTo) => {
  const navigate = useNavigate();
  return (
    <Stack alignItems={'flex-end'}>
      <Link
        underline={'hover'}
        onClick={() => navigate(href ?? '')}
        onKeyDown={onEnterOrEscapeKeyDown}
        tabIndex={0}
      >
        <Stack direction={'row'} gap={'2px'} alignItems={'flex-end'}>
          <Typography variant={'body3'}>{label}</Typography>
          <DynamicArrow color={'blue'} rotate={90} />
        </Stack>
      </Link>
    </Stack>
  );
};
